// Client-only helper to get/create an anonymous session id for Maya tracking.
// Persists in localStorage so events from the same browser cluster together
// even before the visitor signs in.

const KEY = "maya_anon_session_id";

export function getMayaAnonSessionId(): string {
  if (typeof window === "undefined") return "";
  try {
    const existing = window.localStorage.getItem(KEY);
    if (existing) return existing;
    const fresh =
      (crypto as Crypto & { randomUUID?: () => string }).randomUUID?.() ??
      `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    window.localStorage.setItem(KEY, fresh);
    return fresh;
  } catch {
    return "";
  }
}
